import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=582f97b9&scoped=true&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/orderTable.css?vue&type=style&index=0&id=582f97b9&scoped=true&lang=css&"
import style1 from "./OrderTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f97b9",
  null
  
)

export default component.exports